export enum EStates {
  new = 'new',
  qualified = 'qualified',
  opportunity = 'opportunity',
  closed_win = 'closed-win',
  closed_loss = 'closed-loss'
}
